document.addEventListener('DOMContentLoaded', function () {

  // Sticky header shrink
  var header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('shrink', window.scrollY > 40);
    });
  }

  // Mobile nav toggle
  var burger = document.getElementById('burger');
  var navLinks = document.getElementById('navLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', function () { navLinks.classList.toggle('open'); });
    navLinks.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { navLinks.classList.remove('open'); });
    });
  }

  // Scroll reveal + gauge fill animation
  var inEditor = !!(window.Shopify && Shopify.designMode);
  var io = null;

  function fillGauges(scope) {
    scope.querySelectorAll('.gauge-fill[data-target]').forEach(function (fill) {
      var target = fill.getAttribute('data-target');
      requestAnimationFrame(function () { fill.style.width = target + '%'; });
    });
  }

  function revealNow(scope) {
    scope.querySelectorAll('.reveal').forEach(function (el) {
      el.classList.add('in');
      fillGauges(el);
    });
  }

  function observe(scope) {
    var els = scope.querySelectorAll('.reveal:not(.in)');
    if (!els.length) return;
    if (inEditor || !('IntersectionObserver' in window)) {
      // Theme editor previews (and old browsers) skip the animation entirely
      // so sections never get stuck mid-transform when Shopify re-renders them.
      els.forEach(function (el) { el.classList.add('in'); fillGauges(el); });
      return;
    }
    els.forEach(function (el) { io.observe(el); });
  }

  if (!inEditor && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          fillGauges(entry.target);
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
  }

  observe(document);

  // Whenever the theme editor swaps a section's markup back in (on save,
  // on selecting it, or on switching preview size), re-run reveal logic
  // so the new nodes never sit stuck at opacity:0 / translateY(26px).
  document.addEventListener('shopify:section:load', function (e) {
    revealNow(e.target);
  });
  document.addEventListener('shopify:section:select', function (e) {
    revealNow(e.target);
  });
  document.addEventListener('shopify:section:reorder', function () {
    revealNow(document);
  });

  // Toast helper
  var toast = document.getElementById('toast');
  var toastMsg = document.getElementById('toastMsg');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toastMsg.textContent = msg;
    toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('show'); }, 2200);
  }

  // Update cart count badge from Shopify's cart.js
  function refreshCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var el = document.getElementById('cartCount');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // Product card colour swatch -> switch variant id used by add-to-cart button
  document.querySelectorAll('.dot-btn[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.card');
      if (!card) return;
      card.querySelectorAll('.dot-btn').forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');
      var variantId = btn.getAttribute('data-variant-id');
      var addBtn = card.querySelector('.add-cart[data-variant-id]');
      if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);
    });
  });

  // Add-to-cart buttons on product cards / collection / featured grid (AJAX)
  document.querySelectorAll('.add-cart[data-variant-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId || variantId === '') {
        showToast('Select a variant first');
        return;
      }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          btn.disabled = false;
          if (data.status) {
            showToast(data.description || 'Could not add to cart');
          } else {
            var title = btn.getAttribute('data-product-title') || 'Item';
            showToast('Added: ' + title);
            refreshCartCount();
          }
        })
        .catch(function () {
          btn.disabled = false;
          showToast('Something went wrong, please try again');
        });
    });
  });

  // Main product page: variant option selects -> update hidden variant id + price
  var productForm = document.getElementById('product-form');
  if (productForm) {
    var jsonEl = productForm.closest('section').parentElement.querySelector('script[id^="ProductJson-"]');
    var product = null;
    try { product = jsonEl ? JSON.parse(jsonEl.textContent) : null; } catch (err) { product = null; }

    function currentSelectedOptions() {
      var values = [];
      productForm.querySelectorAll('.option-select').forEach(function (sel) {
        values.push(sel.value);
      });
      return values;
    }

    function findMatchingVariant() {
      if (!product) return null;
      var selected = currentSelectedOptions();
      if (selected.length === 0) return product.variants[0];
      var match = product.variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].filter(Boolean);
        return selected.every(function (val) { return opts.indexOf(val) !== -1; });
      });
      return match || product.variants[0];
    }

    function moneyFormat(cents) {
      return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    }

    productForm.querySelectorAll('.option-select').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var variant = findMatchingVariant();
        if (!variant) return;
        var variantIdInput = document.getElementById('variantId');
        if (variantIdInput) variantIdInput.value = variant.id;
        var priceEl = document.getElementById('productPrice');
        if (priceEl) {
          var html = moneyFormat(variant.price);
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            html += ' <span class="old" id="productComparePrice">' + moneyFormat(variant.compare_at_price) + '</span>';
          }
          priceEl.innerHTML = html;
        }
        var addBtn = document.getElementById('addToCartBtn');
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to cart';
          } else {
            addBtn.disabled = true;
            addBtn.textContent = 'Sold out';
          }
        }
      });
    });

    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var formData = new FormData(productForm);
      var payload = {
        items: [{
          id: document.getElementById('variantId').value,
          quantity: parseInt(formData.get('quantity') || '1', 10)
        }]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.status) {
            showToast(data.description || 'Could not add to cart');
          } else {
            showToast('Added to cart');
            refreshCartCount();
          }
        })
        .catch(function () { showToast('Something went wrong, please try again'); });
    });

    // Thumbnail gallery swap
    productForm.closest('section').querySelectorAll('.thumb-btn[data-img]').forEach(function (t) {
      t.addEventListener('click', function () {
        var img = document.getElementById('mainProductImage');
        if (img) img.src = t.getAttribute('data-img');
      });
    });
  }

  refreshCartCount();
});
